import { styled } from 'styled-components';
import { ErrorMessage } from 'formik';

import { Button } from '@vivaahealth/design-system';
import { AnimatedFadeIn } from '../../../../../../styles/animation';

export const ReconciliationContainer = styled(AnimatedFadeIn)`
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 40px;
  background-color: var(--color-white);
  margin-bottom: 2rem;
`;

export const Row = styled.div`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ErrorHint = styled(ErrorMessage)`
  color: var(--color-state-danger);
  font-size: 13px;
`;

export const ContinueButton = styled(Button)`
  width: 100%;
  background-color: var(--action-color) !important;
`;

export const InputLabel = styled.label`
  font-size: 14px;
`;
